module.exports = __webpack_public_path__ + "img/20210906-1630912412355438.0c523b5f.png";